<template>
  <span class="diag-notsupported el-icon-error"></span>
</template>
<script>
export default {
  name: 'diag-notsupported',
}
</script>
<style lang="less">
.diag-notsupported {
  color: #f56c6c;
}
</style>